<template>
  <div class="download-app">
    <section class="download-wrapper flex-vertical flex-ai-c">
      <header class="broadcast flex-basic flex-ai-c">
        <span></span>
        <swiper class="carousel" :options="swiperOptions">
          <swiper-slide v-for="item in userList" :key="item.name" class="carousel-li flex-basic flex-ai-c">
            <p>{{item.name}} {{item.content}}</p>
          </swiper-slide>
        </swiper>
      </header>
      <div class="download-countdown">
        <p>距失效&nbsp;&nbsp;{{countDownText}}</p>
      </div>
      <div class="download-btn" @click="downloadKomoi"></div>
      <div class="download-bottom-img"></div>
    </section>
  </div>
</template>

<script>
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import {Toast} from 'mint-ui'
  import md5 from 'blueimp-md5'
  export default {
    components:{
      swiper,
      swiperSlide
    },
    data(){
      return{
        countDownText:'24:00:00',
        time:86400000,
        userList:[
          {name:'babyqi',content:'提现128元'},
          {name:'心有执念',content:'提现176元'},
          {name:'BOBO',content:'提现168元'},
          {name:'往事如风',content:'提现116元'},
          {name:'瑶',content:'提现91元'},
          {name:'阿雷',content:'提现188元'},
          {name:'luizy',content:'提现135元'},
          {name:'爱走神',content:'提现87元'}
        ],
        swiperOptions:{
          loop:true,
          direction : 'vertical',
          allowTouchMove: false,
          autoplay: {
            delay: 2000,
          }
        }
      }
    },
    created(){
      const self = this;
      self.countDown();
    },
    methods:{
      downloadKomoi(){
        open('https://a.app.qq.com/o/simple.jsp?pkgname=net.kmjx.kmkj');
      },
      countDown(){
        let self = this;
        let clock = setInterval(function(){
          self.time -= 1000;
          if(self.time>=0){
            let runtime = self.time/1000;
            let hour = Math.floor(runtime % 86400/ 3600);
            let minute = Math.floor(runtime % 86400% 3600/ 60);
            let second = runtime% 86400% 3600% 60;
            self.countDownText = hour+':'+(minute<10?'0'+minute:minute)+':'+(second<10?'0'+second:second);
          }else{
            clearInterval(clock);
          }
        },1000)
      },
    }
  }
</script>

<style lang="scss">
  @import "../style/base";
  .download-app{
    width:100%;
    height:100%;
    background-color: #fae7db;
    .download-wrapper{
      width:100%;
      min-height: 1206px;
      box-sizing: border-box;
      padding-top: 9px;
      background-image:url(../img/领取成功@2x.jpg);
      background-size: 750px auto;
      background-repeat: no-repeat;
      .broadcast{
        z-index:1;
        span{
          width:34px;
          height:24px;
          background-image: url(../img/broadcast.png);
          background-size: 34px 24px;
        }
        .carousel{
          overflow: hidden;
          margin-left: 24px;
          height:55px;
          .carousel-li{
            height:55px;
            p{
              line-height: 30px;
              font-size:30px;
              color:#dc8f5a;
            }
          }
        }
      }
      .download-btn{
        margin-top:34px;
        width:474px;
        height:118px;
        background-image: url(../img/下载APP提现按钮小@3x.png);
        background-size: 474px auto;
      }
      .download-countdown{
        margin-top: 806px;
        p{
          font-size:40px;
          color:#ffee9d;
        }
      }
      .download-bottom-img{
        margin-top: 100px;
        width:750px;
        height:1392px;
        background: url(../img/底部图@2x.jpg) center center no-repeat;
        background-size: 750px 1392px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/downloadApp.vue